import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { AssetTypeSettingsFieldsViewTopBar } from "./TopBar"

export const assetTypeFieldsViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: AssetTypeSettingsFieldsViewTopBar,
}
